// @font-face генерируется в рантайме: виджет живёт на чужой странице (Тильда),
// относительные url() в инжектированном <style> резолвились бы против её адреса.
export function fontFaceCss(assetsBase) {
  const face = (family, file, weight) =>
    `@font-face{font-family:'${family}';src:url(${assetsBase}fonts/${file}) format('woff2');` +
    `font-weight:${weight};font-display:swap}`;
  return [
    face("OkinawaNord", "nord-400.woff2", "400"),
    face("OkinawaAurora", "aurora-400.woff2", "400"),
    face("OkinawaAurora", "aurora-600.woff2", "600 700"),
  ].join("\n");
}
